<sh-notification-item visible id="demo-default-inline" inline icon="warning">
  {{ 'tube.message.disclaimer' | translate }}
</sh-notification-item>
<api-call-gate [apiCall]="[history, markers]">
  <ng-template #lastSuccessfulData let-history="$implicit[0]">
    <div
      *ngFor="let tube of history.tubes"
      class="planes"
      style="margin-bottom: 0; padding-bottom: 8px; width: 100%"
    >
      <app-tube-card [tube]="tube"></app-tube-card>
    </div>
  </ng-template>
  <ng-template #error>
    <app-no-data-icon
      [iconName]="'no-findings'"
      error="{{ 'label.noDataTube' | translate }}"
    ></app-no-data-icon>
  </ng-template>
</api-call-gate>
